import {action} from "mobx";
import {GridRow} from "core/grid/domain/grid";


export interface WithTenant {
  $dirty: boolean;
  tenantGroups?: number[];
  tenants?: number[];
}

export const getSelectTenant = (objekt: WithTenant, tenantId: number) => {
  //console.log('getSelectTenant on %O,  %s .. %s = %s', objekt, tenantId, index, objekt.tenants.includes(tenantId));
  return objekt.tenants.includes(tenantId);
};

export const setSelectTenant = action("setSelectTenant-action", (objekt: WithTenant, tenantId: number, item: GridRow, checked: boolean) => {
  let ti = objekt.tenants.indexOf(tenantId);
  if (checked) {
    if (ti === -1) objekt.tenants.push(tenantId);
  } else {
    if (ti >= 0) objekt.tenants.splice(ti, 1);
  }
  objekt.$dirty = true;
  console.log('setSelectTenant objekt = %o, tenantId = %s,  item = %o, checked = %s', objekt, tenantId, item, checked);
});

export const getSelectTenantGroup = (objekt: WithTenant, tenantGroupId: number) => {
  //console.log('getSelectTenant %s .. %s', tenantId, index);
  return objekt.tenantGroups.includes(tenantGroupId);
};

export const setSelectTenantGroup = action("setSelectTenantGroup-action", (objekt: WithTenant, tenantGroupId: number, item: GridRow, checked: boolean) => {
  console.log('setSelectTenant %s .. %so...%s', tenantGroupId, item, checked);
  let ti = objekt.tenantGroups.indexOf(tenantGroupId);
  if (checked) {
    if (ti === -1) objekt.tenantGroups.push(tenantGroupId);
  } else {
    if (ti >= 0) objekt.tenantGroups.splice(ti, 1);
  }
  objekt.$dirty = true;
});





// WEBPACK FOOTER //
// ./src/core/tenant/tenantSelectionSupport.ts